(()=>{
if(window.bulloraSlideMotion)return;
window.bulloraSlideMotion=true;
const selector='.bl-benefit,.bl-redesign .bl-steps article,.bl-help article,.bl-editorial article';
const preference=window.matchMedia('(prefers-reduced-motion: reduce)');
const pending=new Set(),seen=new WeakSet();
let frame=0;
const show=el=>{
 pending.delete(el);
 el.classList.add('bl-reveal-shown');
};
const measure=()=>{
 frame=0;
 const height=Math.min(window.innerHeight,window.visualViewport?window.visualViewport.height:window.innerHeight);
 pending.forEach(el=>{
  if(!el.isConnected){pending.delete(el);return;}
  const r=el.getBoundingClientRect();
  if(preference.matches||el.contains(document.activeElement)||r.bottom<=0||(r.width&&r.height&&r.top<height*.78))show(el);
 });
};
const schedule=()=>{if(!frame)frame=requestAnimationFrame(measure);};
const scan=root=>{
 const found=[...(root.querySelectorAll?root.querySelectorAll(selector):[])];
 if(root.matches&&root.matches(selector))found.unshift(root);
 found.forEach(el=>{
  if(seen.has(el))return;
  seen.add(el);
  const r=el.getBoundingClientRect();
  if(preference.matches||r.top<window.innerHeight*.78)return;
  const siblings=Array.from(el.parentElement.children).filter(e=>e.matches(selector));
  el.style.setProperty('--bl-reveal-x',siblings.indexOf(el)%2?'calc(100% + 48px)':'calc(-100% - 48px)');
  pending.add(el);
  el.classList.add('bl-reveal-ready');
 });
 schedule();
};
const start=()=>{
 window.addEventListener('scroll',schedule,{passive:true});
 window.addEventListener('resize',schedule,{passive:true});
 window.addEventListener('pageshow',schedule);
 document.addEventListener('focusin',schedule);
 document.addEventListener('shopify:section:load',event=>scan(event.target));
 const change=()=>{if(preference.matches)pending.forEach(show);};
 if(preference.addEventListener)preference.addEventListener('change',change);
 else if(preference.addListener)preference.addListener(change);
 scan(document);
 if('MutationObserver'in window)new MutationObserver(records=>{
  records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1)scan(node);}));
 }).observe(document.body,{childList:true,subtree:true});
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
else start();
})();